export default __webpack_public_path__ + "static/media/ser9.8abfb01e.svg";